import XLSX from 'xlsx';
import { dateToString } from './dateToString';

function parseToExport(headers: Record<string, string>, object: Record<string, string | number>[]): Array<string | number>[] {

  const outArray = object.map((obj) => {
    const arr: Array<string | number> = [];

    Object.keys(headers).forEach((key) => {
      arr.push(obj[key]);
    });

    return arr;
  });

  const titles = Object.keys(headers).map((key) => headers[key]);

  return [titles, ...outArray];
}

function exportAndSave(filename: string, rows: Array<string | number>[]): void {
  const workSheet = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, workSheet, filename);

  const currentDate = new Date();
  const date = dateToString(currentDate).split('/').join('-');

  let hours = `${currentDate.getHours()}`;
  if (hours.length === 1) hours = `0${hours}`;

  let minutes = `${currentDate.getMinutes()}`;
  if (minutes.length === 1) minutes = `0${minutes}`;

  XLSX.writeFile(wb, `${filename} ${date}_${hours}-${minutes}.xlsx`);
}

export function exportToExcel(headers: Record<string, string>, object: Record<string, string | number>[], filename: string) {
  const matrixShapeData = parseToExport(headers, object);
  // return matrixShapeData;
  exportAndSave(filename, matrixShapeData);
}
